"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importDefault(require("react"));
const PinCircleSidebar = (props) => {
    return (react_1.default.createElement("svg", { width: "21", height: "22", viewBox: "0 0 21 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("ellipse", { cx: "10.4426", cy: "11", rx: "10.4426", ry: "11", fill: props.fill })));
};
exports.default = PinCircleSidebar;
//# sourceMappingURL=PinCircleSidebar.js.map